import PhotoSwipeTheme from './components/photoswipe';
import MasonryGallery from './components/masonry-gallery';
import Animates from './components/gsap-animations';

/**
 * Calls a supplied function once
 * document has loaded.
 *
 * @param  {CallableFunction} onLoaded
 * @return {void}
 */
const domLoaded = (onLoaded) => {
	if (document.readyState !== 'loading') {
		// Document is already ready, call the callback directly
		onLoaded();
	} else if (document.addEventListener) {
		// All modern browsers to register DOMContentLoaded
		document.addEventListener('DOMContentLoaded', onLoaded);
	} else {
		// Old IE browsers
		document.attachEvent('onreadystatechange', function () {
			if (document.readyState === 'complete') {
				onLoaded();
			}
		});
	}
};

const App = {
	init() {
		// Photoswipe
		setTimeout(() => {
			Array.from(document.querySelectorAll('.pswp-gallery-social')).map(el => new PhotoSwipeTheme(el));
		}, "2000");

		Array.from(document.querySelectorAll( '.gsap-animation' )).map(el => new Animates(el));

		// Masonry Gallery
		Array.from(document.querySelectorAll('.masonry-gallery-social')).map(el => new MasonryGallery(el));
	}
};



domLoaded(() => {
	App.init();
});

// Start function to add custom controls on mobile for hero video
function handleResize() {
	var videoHero = document.querySelector(".site-hero-video video");
	var videoMute = document.querySelector(".mute-bt");
	var playButton = document.querySelector(".play-bt");
	var pauseButton = document.querySelector(".pause-bt");

	if (videoHero && videoMute) {
		videoHero.removeAttribute('controls');
		videoHero.currentTime = 0;

		playButton.style.opacity = "0";

		videoMute.addEventListener("click", function() {
			if (videoHero.muted) {
				videoHero.muted = false;
				videoMute.classList.remove("stop");
			} else {
				videoHero.muted = true;
				videoMute.classList.add("stop");
			}
		});
		playButton.addEventListener("click", function() {
			playButton.style.display = "none";
			pauseButton.style.display = "block";
			videoHero.play();
		});
		pauseButton.addEventListener("click", function() {
			playButton.style.display = "block";
			playButton.style.opacity = "1";
			pauseButton.style.display = "none";
			pauseButton.classList.add("active");
			videoHero.pause();
		});
	}
}

window.addEventListener("resize", handleResize);
handleResize();
// End function to add custom controls on mobile for hero video
$(document).ready( function() {

	const $heroVideo = $('#hero-video');
	if ( $heroVideo.length > 0) {
		const mediaVideo = $heroVideo.get(0);
		const $btnMute = $('.js-video-controls .mute-control');
		const $btnPause = $('.js-video-controls .pause-control');
		const $start = $('.start-icon');

		if ( document.getElementById("hero-embed").classList.contains("mobile-video") ) {
			$btnPause.find('.icon').removeClass('stop');
		}

		$btnPause.on('click', ev => {
			if (mediaVideo.paused) {
				mediaVideo.play();
				$btnPause.find('.icon').removeClass('stop');
			} else {
				mediaVideo.pause();
				$btnPause.find('.icon').addClass('stop');
			}
		});
		$btnMute.on('click', ev => {
			if (mediaVideo.muted) {
				$btnMute.find('.icon').addClass('stop');
			} else {
				$btnMute.find('.icon').removeClass('stop');
			}
			mediaVideo.muted = !mediaVideo.muted;
		});

		$start.on('click', ev => {
			mediaVideo.play();
			$start.addClass( 'd-none' );
		});
	}

	const the_menus_item = document.querySelector('.the-menus-link');
	if (the_menus_item){
		the_menus_item.setAttribute('data-bs-toggle', 'offcanvas');
	}

	function masonry_style() {
		let imgs = document.querySelectorAll('.masonry-gallery .gallery-item');
		if (imgs != null && imgs.length > 0) {
			for (let i = 0; i < imgs.length; i++) { imgs[i].classList.remove('masonry-m-odd'); }

			let $gallery = $('.masonry-gallery');
			$gallery.isotope('layout');
		}
	}
	masonry_style();

	if (document.body.classList.contains('page-template-reservations')) {
		if ( document.getElementById( 'reservation-form' ) ) {
			let wpml_lunch = document.getElementById('wpml-lunch').innerText;
			let wpml_dinner = document.getElementById('wpml-dinner').innerText;
			let label_people = document.getElementById('label-people');
			let label_date = document.getElementById('label-date');
			let label_hour = document.getElementById('label-hour');
			let selectedDayIndex = -1;
			let currentCalState = true;
			let weekDayNames = [];
			function getWeekDayNames() {
				let calWeekdays = document.querySelectorAll('.flatpickr-weekdays .flatpickr-weekdaycontainer .flatpickr-weekday');
				for (let i=0; i<calWeekdays.length; i++) {
					weekDayNames.push(calWeekdays[i].innerText);
				}
			}
			function weekDaySafeGuard(reset=false) { return;
				let calWeekdays = document.querySelectorAll('.flatpickr-weekdays .flatpickr-weekdaycontainer .flatpickr-weekday');

				if (reset) {
					for (let i=0; i<calWeekdays.length; i++) {
						calWeekdays[i].innerText = weekDayNames[i];
					}
					return;
				}

				const today = new Date();
				let todayNum = today.getDay();
				if (todayNum != 0) {
					let weekDaysSubBefore = weekDayNames.slice(0, todayNum);
					let weekDaysSubAfter = weekDayNames.slice(todayNum,8);
					let fixedWeekDays = weekDaysSubAfter.concat(weekDaysSubBefore);
					for (let i=0; i<calWeekdays.length; i++) {
						calWeekdays[i].innerText = fixedWeekDays[i];
					}
				}
			}
			function toggleCalendar(visible) {
				let calMonths = document.querySelector('.flatpickr-months');
				if (visible === false) {
					if (calMonths != null){
						calMonths.classList.add('d-none');
						document.querySelector('.dayContainer').classList.remove('expanded');
					}

					let days = document.querySelectorAll('.flatpickr-days .dayContainer span');
					for (let i=0; i<days.length; i++) {
						days[i].classList.add('d-none');
					}
					toggleDays();
				}
				else {
					calMonths.classList.remove('d-none');
					document.querySelector('.dayContainer').classList.add('expanded');
					let days = document.querySelectorAll('.flatpickr-days .dayContainer span');
					for (let i=0; i<days.length; i++) {
						days[i].classList.remove('d-none');
					}
				}
				currentCalState = visible;
			}
			function toggleDays() {
				let days = document.querySelectorAll('.flatpickr-days .dayContainer span');
				selectedDayIndex=-1;
				for (let i=0; i<days.length; i++) {
					if (days[i].classList.contains('selected')) {
						selectedDayIndex = Math.floor(i/7) * 7;
						break;
					}
				}
				if (selectedDayIndex === -1) {
					for (let i=0; i<days.length; i++) {
						if (days[i].classList.contains('today')) {
							selectedDayIndex = i;
							break;
						}
					}
				}
				if ( selectedDayIndex !== -1) {
					for (let i=selectedDayIndex; i<selectedDayIndex+7; i++) {
						if (typeof days[i] !== 'undefined')
							days[i].classList.remove('d-none');
					}
				}
				else {
					let picker = document.getElementById('res-picker');
					if (typeof picker._flatpickr != 'undefined') {
						picker._flatpickr.setDate('today');
						toggleCalendar(false);
					}
				}
			}
			toggleCalendar(false);
			function strToDate(str) {
				var parts = str.split('-');
				return new Date(parts[2], parts[1] - 1, parts[0]);
			}
			function getDateNumber(dateStr) {
				var parts = dateStr.split('-');
				var myDate = new Date(parts[2], parts[1] - 1, parts[0]);
				return myDate.getDay();
			}
			function getDayName(dateStr, locale) {
				var date = new Date(dateStr);
				return date.toLocaleDateString(locale, { weekday: 'long' });
			}
			function getMonthName(dateStr, locale) {
				var date = new Date(dateStr);
				return date.toLocaleDateString(locale, { month: 'short' });
			}
			function disableAllTimes() {
				let dinners = document.querySelectorAll('.dinner-day');
				let lunches = document.querySelectorAll('.lunch-day');
				for (let i=0; i<dinners.length; i++) {dinners[i].classList.add('d-none');}
				for (let i=0; i<lunches.length; i++) {lunches[i].classList.add('d-none');}
			}
			function todayFormatted() {
				let today = new Date();
				const yyyy = today.getFullYear();
				let mm = today.getMonth() + 1; // Months start at 0!
				let dd = today.getDate();

				if (dd < 10) dd = '0' + dd;
				if (mm < 10) mm = '0' + mm;
				today = dd + '-' + mm + '-' + yyyy;
				return today;
			}
			function toggleSelectedTimeTable(selectedDayNumber) {
				disableAllTimes();
				let l = document.querySelector('.lunch-day-' + selectedDayNumber);
				let d = document.querySelector('.dinner-day-' + selectedDayNumber);

				if (typeof l !== 'undefined') {
					l.classList.remove('d-none');
				}
				if (typeof d !== 'undefined') {
					d.classList.remove('d-none');
				}
			}
			function updateReservationLabels() {
				let resType = document.getElementById('reservationType').value;
				let peopleVal = document.getElementById('people_value').innerText;
				let str = resType === 'Dinner' ? wpml_dinner : wpml_lunch;
				label_people.innerText = str + " " + peopleVal;
				let currentDateStr = document.getElementById('res-picker').value !== '' ? document.getElementById('res-picker').value : todayFormatted();
				let currentDate = strToDate(currentDateStr);
				let day = getDayName(currentDate, $('html')[0].lang);
				let month = getMonthName(currentDate, $('html')[0].lang);
				let dayOfWeek = currentDate.getDate();
				let nth = function(d) {
					if ($('html')[0].lang == 'en-US') {
						if (d > 3 && d < 21) return 'th';
						switch (d % 10) {
						case 1:
							return "st";
						case 2:
							return "nd";
						case 3:
							return "rd";
						default:
							return "th";
						}
					} else {
						return '';
					}
				};
				label_date.innerText = day + " " + month + " " + dayOfWeek + nth(dayOfWeek);
				label_hour.innerText = document.getElementById('reservationHour').value !== '' ? "@" + document.getElementById('reservationHour').value : '-';
			}
			function resTypeSetValue(val, t) {
				document.getElementById('reservationType').value = val;
				document.getElementById('reservationType').setAttribute('value',val);
				document.getElementById('reservationHour').value = t.innerText;
				document.getElementById('reservationHour').setAttribute('value',t.innerText);
				resetButtons();
				t.classList.add('res-selected');
				updateReservationLabels();
			}
			function resetValues() {
				document.getElementById('reservationHour').value = '';
				document.getElementById('reservationHour').setAttribute('value','');
			}
			updateReservationLabels();
			toggleSelectedTimeTable(getDateNumber(todayFormatted()));
			function onDateChange() {
				let cf7_dates = document.getElementById('date');
				cf7_dates.value = document.getElementById('res-picker').value;
				if (currentCalState === false) {
					toggleCalendar(false, true);

				}
				let v = document.getElementById('res-picker').value !== '' ? document.getElementById('res-picker').value : todayFormatted();
				let selectedDayNumber = getDateNumber(v);
				toggleSelectedTimeTable(selectedDayNumber);
				resetValues();
				updateReservationLabels();
			}
			document.getElementById('toggleCalendar').addEventListener('click', () => {
				if (currentCalState == true) {
					let picker = document.getElementById('res-picker');
					let pickerField = document.getElementById('res-picker');
					let dd = pickerField.value.split('-');
					if (dd.length != 0) {
						let fixedSelected = dd[1] + "-" + dd[0] + "-" + dd[2]
						var fixedSelectedDate = new Date(fixedSelected);
						var today = new Date();

						var date1 = Date.UTC(fixedSelectedDate.getFullYear(), fixedSelectedDate.getMonth(), fixedSelectedDate.getDate());
						var date2 = Date.UTC(today.getFullYear(), today.getMonth(), today.getDate());
						var ms = Math.abs(date1-date2);
						if (Math.floor(ms/1000/60/60/24) > 7) {
							picker._flatpickr.setDate('today');
						}
					}

				}
				toggleCalendar(!currentCalState);

				weekDaySafeGuard(currentCalState);
			});
			class DatePicker {
				constructor(checkInEl = null) {
					if ( checkInEl ) {
						this.checkInEl = checkInEl;

						// flatpickr.l10ns.default.firstDayOfWeek = 1; // Monday
						// flatpickr.localize(flatpickr.l10ns.gr); // Use greek language

						flatpickr(this.checkInEl, {
							locale: $('html')[0].lang == 'el' ? 'gr' : $('html')[0].lang,
							minDate: 'today',
							dateFormat: 'd-m-Y',
							//plugins: [new rangePlugin({ input: checkOutEl})],
							disableMobile: 'true',
							inline: true,
							defaultDate: "today",
							onChange : function() {
								onDateChange();
							}
						});
					}
				}
			}
			let picker = document.getElementById('res-picker');
			if (picker) {
				let checkinField = new DatePicker(picker);
				getWeekDayNames();
				toggleCalendar(false);
				weekDaySafeGuard();
			}
			let people_value = document.getElementById('people_value');
			let cf7_people = document.getElementById('people');
			let occupancy_min = parseInt(document.getElementById('occupancy_min').innerText);
			let occupancy_max = parseInt(document.getElementById('occupancy_max').innerText);
			cf7_people.value = occupancy_min;
			document.getElementById('people_minus').addEventListener('click', function() {
				let v = parseInt(people_value.innerText);
				if ( v > occupancy_min ) {
					v--;
					document.getElementById('people_value').innerText = v.toString();
					document.getElementById('people').value = v.toString();
					updateReservationLabels();
				}
			});
			document.getElementById('people_add').addEventListener('click', function() {
				let v = parseInt(people_value.innerText);
				if ( v < occupancy_max ) {
					v++;
					document.getElementById('people_value').innerText = v.toString();
					document.getElementById('people').value = v.toString();
					updateReservationLabels();
				}
			});
			let lunch_buttons = document.querySelectorAll('.res-lunch');
			let dinner_buttons = document.querySelectorAll('.res-dinner');
			function resetButtons() {
				for (let i = 0; i < lunch_buttons.length; i++) {
					lunch_buttons[i].classList.remove('res-selected');
				}
				for (let i = 0; i < dinner_buttons.length; i++) {
					dinner_buttons[i].classList.remove('res-selected');
				}
			}
			for (let i = 0; i < lunch_buttons.length; i++) {
				let self = lunch_buttons[i];
				self.addEventListener('click', function (event) {
					resTypeSetValue('Lunch', this);
				}, false);
			}
			for (let i = 0; i < dinner_buttons.length; i++) {
				var self = dinner_buttons[i];
				self.addEventListener('click', function (event) {
					resTypeSetValue('Dinner', this);
				}, false);
			}
			function todayFormat() {
				let today = new Date();
				const yyyy = today.getFullYear();
				let mm = today.getMonth() + 1; // Months start at 0!
				let dd = today.getDate();

				if (dd < 10) dd = '0' + dd;
				if (mm < 10) mm = '0' + mm;
				today = dd + '-' + mm + '-' + yyyy;
				return today;
			}

			setTimeout(() => {
				let date = document.getElementById('date');
				if ( date.value == "" ) {
					date.value = todayFormat();
					console.log(date.value)
				}
				let people = document.getElementById('people');

				if ( people.value == "" ) {
					people.value = document.getElementById('occupancy_min').innerHTML;
					console.log(people.value);
				}
			},300);
		}
	}
});

const the_menus_item = document.querySelector('.menu-item-type-custom');
if (the_menus_item){
	the_menus_item.setAttribute('data-bs-toggle', 'offcanvas');
}
